import { createFileRoute, redirect, useNavigate, useParams } from '@tanstack/react-router';
import { Agreements } from '@pages/agreements';
import { useGetAgreements } from '@services/global/agreements/list';
import { Loader } from '@components/loader';

const StaffAgreements = () => {
  const navigate = useNavigate();
  const { localId } = useParams({ from: '/u/$localId/_staff/staff/agreements/' });
  const { meta, data, isPending } = useGetAgreements();

  if (isPending) return <Loader />;

  return (
    <Agreements
      meta={meta}
      agreements={data}
      onRowSelect={(id) => {
        navigate({
          to: '/u/$localId/staff/agreements/$id/orders',
          params: { id, localId },
        }).catch((err) => console.error(err));
      }}
    />
  );
};

export const Route = createFileRoute('/u/$localId/_staff/staff/agreements/')({
  beforeLoad: ({ context }) => {
    if (!context.userHasPermissions(['agreements_read'])) {
      throw redirect({
        to: `/u/$localId/${context.userType}/forbidden`,
      });
    }
  },
  component: StaffAgreements,
});
